import React from 'react';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
    return (
    <>
        <div className="policy-page">
            <div className="policy-container">
                <h1>Terms & Conditions</h1>
                <p className="last-updated">Last Updated: May 2026</p>

                <section>
                    <h2>1. Agreement to Terms</h2>
                    <p>
                        By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                    </p>
                </section>

                <section>
                    <h2>2. Use License</h2>
                    <p>
                        Permission is granted to temporarily download one copy of the materials (information or software) on Bluewave Co.'s website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                    </p>
                    <ul>
                        <li>Modifying or copying the materials</li>
                        <li>Using the materials for any commercial purpose or for any public display</li>
                        <li>Attempting to decompile or reverse engineer any software contained on the website</li>
                        <li>Removing any copyright or other proprietary notations from the materials</li>
                        <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
                        <li>Violating any applicable laws or regulations</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Disclaimer</h2>
                    <p>
                        The materials on Bluewave Co.'s website are provided on an 'as is' basis. Bluewave Co. makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                    </p>
                </section>

                <section>
                    <h2>4. Limitations</h2>
                    <p>
                        In no event shall Bluewave Co. or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Bluewave Co.'s website, even if Bluewave Co. or a Bluewave Co. authorized representative has been notified orally or in writing of the possibility of such damage.
                    </p>
                </section>

                <section>
                    <h2>5. Accuracy of Materials</h2>
                    <p>
                        The materials appearing on Bluewave Co.'s website could include technical, typographical, or photographic errors. Bluewave Co. does not warrant that any of the materials on its website are accurate, complete, or current. Bluewave Co. may make changes to the materials contained on its website at any time without notice.
                    </p>
                </section>

                <section>
                    <h2>6. Links</h2>
                    <p>
                        Bluewave Co. has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Bluewave Co. of the site. Use of any such linked website is at the user's own risk.
                    </p>
                </section>

                <section>
                    <h2>7. Modifications</h2>
                    <p>
                        Bluewave Co. may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
                    </p>
                </section>

                <section>
                    <h2>8. Governing Law</h2>
                    <p>
                        These terms and conditions are governed by and construed in accordance with the laws of Sri Lanka, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                    </p>
                </section>

                <section>
                    <h2>9. User Responsibilities</h2>
                    <p>
                        Users of this website agree to:
                    </p>
                    <ul>
                        <li>Provide accurate and truthful information</li>
                        <li>Not engage in any unlawful or harmful activities</li>
                        <li>Not attempt to gain unauthorized access to our systems</li>
                        <li>Respect intellectual property rights</li>
                        <li>Not transmit viruses or malicious code</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Intellectual Property Rights</h2>
                    <p>
                        All content on this website, including text, graphics, logos, images, and software, is the property of Bluewave Co. or its content suppliers and is protected by international copyright laws. Unauthorized use of any content is prohibited.
                    </p>
                </section>

                <section>
                    <h2>11. Limitation of Liability</h2>
                    <p>
                        In no event shall Bluewave Co. be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website or materials, even if we have been advised of the possibility of such damages.
                    </p>
                </section>

                <section>
                    <h2>12. Contact Information</h2>
                    <p>
                        If you have any questions about these Terms & Conditions, please contact us at:
                    </p>
                    <p>
                        <strong>Email:</strong> <a href="mailto:info@bluewavesshipmanagement.com">info@bluewavesshipmanagement.com</a><br />
                        <strong>Phone:</strong> <a href="tel:+94719645645">+94 719 745 745</a>
                    </p>
                </section>

                <section>
                    <h2>13. Severability</h2>
                    <p>
                        If any provision of these terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.
                    </p>
                </section>
            </div>
        </div>
        <Footer />
        </>
    );
};

export default TermsAndConditions;
